import { FlexRow } from '@/src/components/flex'
import { appColors } from '@/src/theme/foundations/colors'
import { Box, Tooltip } from '@chakra-ui/react'
import type { ReactNode } from 'react'
import { Info as InfoIcon } from 'react-feather'
import { BaseText } from './BaseText'

type InfoBoxVariant = 'info' | 'amberLight'

const infoBoxVariantColors: Record<InfoBoxVariant, { bgColor: string; borderColor: string; textColor: string; iconColor: string }> = {
  info: {
    bgColor: appColors.blue['100'],
    borderColor: appColors.blue['200'],
    textColor: appColors.blue['800'],
    iconColor: appColors.foreground,
  },
  amberLight: {
    bgColor: appColors.amber['100'],
    borderColor: appColors.amber['400'],
    textColor: appColors.amber['800'],
    iconColor: appColors.amber['800'],
  },
}

interface InfoBoxProps {
  measureTitle?: string
  description: string | ReactNode
  tooltipLabel?: string
  variant?: InfoBoxVariant
}

export const InfoBox = ({ measureTitle, description, tooltipLabel, variant = 'info' }: InfoBoxProps) => (
  <Box
    bg={infoBoxVariantColors[variant].bgColor}
    p='12px'
    borderRadius='md'
    borderColor={infoBoxVariantColors[variant].borderColor}
    borderWidth='1px'
    data-testid='info-box-shared'
  >
    <FlexRow gap='8px' alignItems='center'>
      <Tooltip label={tooltipLabel} bg='white' color='gray.800' fontWeight='normal' borderRadius='base' hasArrow>
        <InfoIcon size={16} color={infoBoxVariantColors[variant].iconColor} style={{ minWidth: 16, minHeight: 16 }} />
      </Tooltip>
      <BaseText
        textStyle='base/text-base Medium'
        color={infoBoxVariantColors[variant].textColor}
        fontSize={14}
        fontWeight={86}
        width={'100%'}
      >
        {measureTitle && (
          <Box as='span' fontWeight={500}>
            {measureTitle}:
          </Box>
        )}
        <Box as='span'>{description}</Box>
      </BaseText>
    </FlexRow>
  </Box>
)
